<div class="ui container">
  <div class="ui inverted very padded segment">
    <h3>Sorry</h3>
    <p>Creating new bounties has been disabled for now. This is due to lack of overall interest in the project.</p>
  </div>
</div>